import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryService } from '../service/country.service';
import { HttpService } from '../service/http.service';
import { SchoolCourseEditComponent } from '../school-course-edit/school-course-edit.component';
import { SchoolEditComponent } from '../school-edit/school-edit.component';
import { SchoolFileUploadComponent } from '../school-file-upload/school-file-upload.component';
import { SchoolUrlEditComponent } from '../school-url-edit/school-url-edit.component';
import { SchoolService } from '../service/school.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService, MenuItem, SelectItem } from 'primeng/api';

@Component({
  selector: 'app-school-edit-navigation',
  templateUrl: './school-edit-navigation.component.html',
  styleUrls: ['./school-edit-navigation.component.css'],
  providers: [SchoolService]
})
export class SchoolEditNavigationComponent implements OnInit {

  @ViewChild("editComponent") schoolEditComponent!: SchoolEditComponent;
  @ViewChild("fileUpload") schoolFileUploadComponent!: SchoolFileUploadComponent;
  @ViewChild("schoolUrl") schoolUrlEditComponent!: SchoolUrlEditComponent;
  @ViewChild("editCourse") schoolCourseEditComponent!: SchoolCourseEditComponent;

  constructor(
    private route: ActivatedRoute,
    public schoolService: SchoolService,
    private httpService: HttpService,
    private countryService: CountryService,
    private builder: FormBuilder,
    private router: Router,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService
  ) { }

  requestId!: number;
  navigationItems: MenuItem[] = [];
  activeItemId = 1;
  activeItem!: SelectItem;

  ngOnInit(): void {
    this.navigationItems = [
      { id: "1", label: "Main", command: () => this.activeItemId = 1 },
      {
        id: "5", label: "Course", command: () => {
          this.activeItemId = 5;
        }
      },
      {
        id: "3", label: "Files", command: () => {
          this.activeItemId = 3;
        }
      }, 
      {
        id: "4", label: "Quotations", command: () => {
          this.activeItemId = 4;
        }
      },
      {
        id: "6", label: "Bookings", command: () => {
          this.activeItemId = 6;
        }
      }
    ];

    this.initSchoolForm();
    this.schoolService.selectedSchoolId = parseInt(this.route.snapshot.paramMap.get("schoolId")!);

    this.httpService.getAllCountries().subscribe(res => this.schoolService.countries = res);
    this.httpService.getAllProgrammeTypes().subscribe(res => this.schoolService.programmeTypes = res);
    this.httpService.getLanguages().subscribe(res => this.schoolService.languages = res);
  }

  initSchoolForm() {
    this.countryService.getRegions().subscribe(res => {
      this.schoolService.itemGroups = res;
      this.httpService.getSchoolById(this.schoolService.selectedSchoolId)
        .subscribe(school => {
          this.schoolService.selectedSchool = school;
          this.schoolService.schoolForm = this.builder.group({
            name: school.name,
            comment: school.schoolMemo ? school.schoolMemo.comment : "",
            hasOnlineCourse: [school.hasOnlineCourse, Validators.required],
            onlineCourseDescription: school.onlineCourseDescription,
            countries: new FormArray([]),
            courses: new FormArray([]),
            programmeTypes: new FormArray([]),
            siteUrl: school.siteUrl,
            street: school.street,
            postalCode: school.postalCode,
            city: school.city,
            phoneNumber: school.phoneNumber,
            internalName: school.internalName,
            code: school.code,
            officialName: school.officialName,
            appointmentTime: school.appointmentTime,
            requireStudentAddress: school.requireStudentAddress,
            requireStudentPhoneNumber: school.requireStudentPhoneNumber,
            lviPageUrl: school.lviPageUrl,
            googleSheetUrl: school.googleSheetUrl,
            defaultBank: school.defaultBank,
            language: school.language,
            emergencyPhoneNumber: school.emergencyPhoneNumber,
            requireSchoolAddress: school.requireSchoolAddress,
            programmeInformations: this.builder.array([]),
            externalName: school.externalName,
            homeCountry: school.homeCountry
          });
          this.schoolService.initCountriesForm();
          this.schoolService.initCourseForm();
          this.schoolService.initProgrammeTypesForm();
          this.schoolService.initProgrammeInformationsForm();
          if(school.isDeleted){
            this.schoolService.schoolForm.disable();
          }
        });
    });
  }


  submit() {
    switch (this.activeItemId) {
      case 1:
        this.schoolEditComponent.sendForm();
        break;
      case 3:
        this.schoolFileUploadComponent.submitAll();
        break;
      case 5:
        this.schoolCourseEditComponent.updateCourses();
    }
  }

  deleteSchool() {
    this.confirmationService.confirm({
      header: "Delete school id: " + this.schoolService.selectedSchool.id,
      message: "Are you sure that you want to delete this school?",
      accept: () => {
        this.httpService.deleteSchoolById(this.schoolService.selectedSchool.id!)
          .subscribe(() => {
            this.toastService.addSuccess("deleted", "successfully deleted");
            if (this.schoolService.selectedSchool.hasOnlineCourse) {
              this.router.navigateByUrl("/management/online-courses");
            } else {
              this.router.navigateByUrl("/management/schools");
            }
          }, error => {
            this.toastService.addError("delete failed", "this couldn't be deleted.");
          });
      }
    });
  }

  restoreSchool(){
    this.confirmationService.confirm({
      header: "Restore school id: " + this.schoolService.selectedSchool.id,
      message: "Are you sure that you want to restore this school?",
      accept: () => {
        this.httpService.restoreSchoolById(this.schoolService.selectedSchool.id!)
          .subscribe(() => {
            this.toastService.addSuccess("Success", "successfully restored");
            if (this.schoolService.selectedSchool.hasOnlineCourse) {
              this.router.navigateByUrl("/management/online-courses");
            } else {
              this.router.navigateByUrl("/management/schools");
            }
          }, error => {
            this.toastService.addError("Failed", "this couldn't be restored.");
          });
      }
    });
  }
}
